export default {
    'N': []
}